import { render, staticRenderFns } from "./ModalRequirements.vue?vue&type=template&id=b18a6b7a&"
import script from "./ModalRequirements.vue?vue&type=script&lang=js&"
export * from "./ModalRequirements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports